import { NavigateFunction } from 'react-router-dom';

class NavigationManager {
  private static instance: NavigationManager;
  private navigate: NavigateFunction | null = null;

  private constructor() {
    //
  }

  public static getInstance(): NavigationManager {
    if (!NavigationManager.instance) {
      NavigationManager.instance = new NavigationManager();
    }
    return NavigationManager.instance;
  }

  public setNavigate(navigate: NavigateFunction): void {
    this.navigate = navigate;
  }

  public navigateToCourse(
    branchId: number,
    programId: number,
    courseId: number,
  ): void {
    if (!this.navigate) {
      console.error('Navigate function is not set in NavigationManager');
      return;
    }
    const path = `/campuses/${branchId}/programs/${programId}/courses/${courseId}`;
    this.navigate(path);
  }
}

export default NavigationManager.getInstance();
